<div class="root-div">
  <p-toolbar class="custom-toolbar">
    <ng-template #start>
      <app-create-node></app-create-node>
      <div>
        <app-project-selector></app-project-selector>
      </div>
      <span class="slash-divider">/</span>
      <app-label-name></app-label-name>
    </ng-template>

    <ng-template #center></ng-template>

    <ng-template #end>
      <app-status-graph [width]="'300px'" [height]="'20px'" [applySpaceClass]="true"></app-status-graph>
      <app-status-percentage class="margin-left"></app-status-percentage>
    </ng-template>
  </p-toolbar>
</div>
